import { showLoading, hideLoading } from 'react-redux-loading-bar';

import locale from '../utils/localization.json';
import {
    cancelAnalysis,
    deletePointCloud,
    getPointClouds,
    uploadPointCloud,
} from '../services/pointcloudService';
import { shortString } from './../utils/string';
import { infoMessage, successMessage } from './../utils/message';
import { deleteCache } from '../utils/cache';

export const getAllPointClouds = () => {
    return async (dispatch) => {
        try {
            dispatch(showLoading());

            const statuses = ['inprogress', 'analyzed'];

            const { status, data } = await getPointClouds();
            if (status === 200) {
                const pointclouds = data.map(({ name, lastModified, url }) => {
                    let status = name
                        .split(/\.(?=[^.]+$)/)[0]
                        .split(/_(?=[^_]+$)/)[1];
                    let type;
                    let modelId;

                    if (statuses.includes(status)) {
                        modelId = name
                            .split(/\.(?=[^.]+$)/)[0]
                            .split(/_(?=[^_]+$)/)[0]
                            .split(/_(?=[^_]+$)/)[1];
                        type = name
                            .split(/\.(?=[^.]+$)/)[0]
                            .split(/_(?=[^_]+$)/)[0]
                            .split(/_(?=[^_]+$)/)[0]
                            .split(/_(?=[^_]+$)/)[1];
                    } else {
                        type = status;
                        status = null;
                    }

                    return {
                        filename: name,
                        name: name
                            .split(/\.(?=[^.]+$)/)[0]
                            .split('_' + type)[0],
                        type,
                        status,
                        modelId,
                        date: lastModified,
                        url,
                    };
                });

                await dispatch({
                    type: 'INIT_POINTCLOUD',
                    payload: pointclouds,
                });
            }
        } catch {
        } finally {
            dispatch(hideLoading());
        }
    };
};

export const uploadNewPointCloud = (file, callback) => {
    return async (dispatch, getState) => {
        const lang = getState().language;

        const filename = file.get('files').name;
        const [name, type] = filename.split(/\.(?=[^.]+$)/);

        const body = new FormData();
        body.append('files', file.get('files'), `${name}_${type}.${type}`);

        try {
            infoMessage(
                `"${shortString(filename, 23)}" ${
                    locale[lang].uploadStart1
                }${'\n'}${locale[lang].uploadStart2}`
            );
            const config = {
                onUploadProgress: callback,
            };

            const { status } = await uploadPointCloud(body, config);

            if (status === 200) {
                successMessage(
                    `"${shortString(filename, 23)}" ${locale[lang].uploaded}`
                );
                dispatch(getAllPointClouds());
            }
        } catch {}
    };
};

export const handlePointCloudDelete = (name, type, modelId) => {
    return async (dispatch, getState) => {
        const lang = getState().language;
        const pointclouds = getState().pointclouds;
        const filteredPointclouds = pointclouds.filter(
            (p) =>
                p.name === name &&
                p.type === type &&
                (!modelId || (p.modelId === modelId && p.status === 'analyzed'))
        );

        const filenames = filteredPointclouds.map(({ filename }) => filename);
        const urls = filteredPointclouds.map(({ url }) => url);

        try {
            const { status } = await deletePointCloud(filenames);
            urls.forEach((url) => deleteCache(url));

            if (status === 200) {
                successMessage(
                    `"${shortString(`${name}.${type}`, 23)}" ${
                        locale[lang].deleted
                    }`
                );

                dispatch(getAllPointClouds());

                if (!modelId) {
                    const inprogress = filteredPointclouds.filter(
                        (p) => p.status === 'inprogress'
                    );

                    inprogress.forEach(({ name, type, modelId }) =>
                        cancelAnalysis(
                            {
                                name: `${name}_${type}.txt`,
                            },
                            modelId
                        )
                    );
                }
            }
        } catch {}
    };
};

export const updatePointCloudStatus = (filename) => {
    return async (dispatch, getState) => {
        const pointclouds = getState().pointclouds;
        const updatedPointclouds = [...pointclouds];
        const index = updatedPointclouds.findIndex(
            (p) => p.filename === filename
        );

        if (index >= 0) {
            updatedPointclouds[index].status = 'waiting';
        }

        await dispatch({
            type: 'UPDATE_POINTCLOUD',
            payload: updatedPointclouds,
        });
    };
};
